// The app registration this page signs in with. Neither value is secret: a SPA's client id is sent
// with every sign-in request. See MySchedule_Plugin/doc/ci-and-storage.md.
export const tenantId = "8ec916fd-9fce-46d6-aca0-4327d570d55b"
export const clientId = "63c4ae3c-bf90-4bf3-bba2-92aa43759294"

export const storageAccount = "stmyschedule"
export const repositoryUrl = "https://github.com/Asprova-Corporation/MySchedule"
